import { render, staticRenderFns } from "./input_sk_atas_keberatan_pbb.vue?vue&type=template&id=b8908f9a&"
import script from "./input_sk_atas_keberatan_pbb.vue?vue&type=script&lang=js&"
export * from "./input_sk_atas_keberatan_pbb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports